// src/components/quiz/MyQuizIDShareComponent.tsx
import React, { useState } from 'react';
import { Mail, Twitter, Copy, X } from 'lucide-react';

interface MyQuizIDShareComponentProps {
    quizId: string;
    onClose: () => void;
    quizTitle: string; // タイトルを追加
}

const appName = "QuizA";
const appUrl = "http://localhost:3000/Top"; // 後で修正するURL

const MyQuizIDShareComponent: React.FC<MyQuizIDShareComponentProps> = ({ quizId, onClose, quizTitle }) => {
    const [copied, setCopied] = useState(false);

    /** クイズIDをクリップボードにコピーするハンドラ */
    const handleCopy = () => {
        navigator.clipboard.writeText(`ID_${quizId}`);
        setCopied(true);
        // 2秒後にコピー状態をリセット
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    /** メールで共有するハンドラ */
    const handleShareViaEmail = () => {
        const subject = encodeURIComponent(`クイズを共有: ${quizTitle}`);
        const body = encodeURIComponent(
            `面白いクイズを見つけました！\n\nクイズ名: ${quizTitle}\nクイズID:「ID_${quizId}」\n\nアプリ「${appName}」でこのIDを使ってクイズを探してみてください！\n${appUrl}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
        onClose();
    };

    /** X (Twitter)で共有するハンドラ */
    const handleShareViaTwitter = () => {
        const tweetText = encodeURIComponent(
            `アプリ「${appName}」で #${quizTitle} というクイズをプレイしました！\nクイズID:「ID_${quizId}」\n\nあなたも挑戦してみませんか？\n${appUrl}`
        );
        window.open(`https://twitter.com/intent/tweet?text=${tweetText}`, '_blank');
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
            <div className="relative p-5 border w-96 shadow-lg rounded-md bg-white">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-200"
                    aria-label="閉じる"
                >
                    <X size={20} />
                </button>
                <h3 className="text-lg font-bold text-center mb-4">クイズIDをシェア</h3>
                <p className="text-sm text-center text-gray-500 mb-4">
                    このクイズのIDを友達に共有して、一緒に楽しみましょう！
                </p>
                <div className="flex flex-col space-y-3">
                    <button
                        onClick={handleShareViaEmail}
                        className="flex items-center justify-center p-3 border rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        <Mail size={20} className="mr-2" /> メールで共有
                    </button>
                    <button
                        onClick={handleShareViaTwitter}
                        className="flex items-center justify-center p-3 border rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        <Twitter size={20} className="mr-2" /> X (Twitter)で共有
                    </button>
                    <button
                        onClick={handleCopy}
                        className="flex items-center justify-center p-3 border rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        <Copy size={20} className="mr-2" /> クイズIDをコピー
                    </button>
                </div>
                {copied && (
                    <div className="mt-4 p-2 text-center text-sm text-green-700 bg-green-100 rounded-md">
                        クイズIDがクリップボードにコピーされました！
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyQuizIDShareComponent;